import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesUp, faAnglesDown, faPlusSquare, faMinusSquare } from "@fortawesome/free-solid-svg-icons";
import { gsap } from "gsap";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import "./PositionsSupplier.css";
import SearchField from "../SearchField/SearchField";
import ListWithFilters from "../ListWithFilters/ListWithFilters";
import { ignoreEnter } from "./utils/inputhandlers";
import useLoadSupPositionToEdit from "./hooks/useLoadSupPositionToEdit";
import useGeneralPosition from "../../hooks/useGeneralPosition";

const PositionsSupplier = () => {
  // General
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();
  // Context Values
  const {
    positionInit,
    positionDataInit,
    containerInit,
    containerDataInit,
    bulkInit,
    bulkDataInit,
    paytermInit,
    paytermDataInit,
    position,
    setPosition,
    positionData,
    setPositionData,
  } = useGeneralPosition();

  //Refs
  const psearchRef = useRef(null);
  const SPMRef = useRef(null);

  // States
  const [noteswarning, setNoteswarning] = useState(); //warning for notes field

  // Position to Edit (ID)
  const [editing, setEditing] = useState(false);
  const [positiontoedit, setPositiontoedit] = useState(null);
  const [reloadposition, setReloadposition] = useState(false);
  const [editingGeneral, setEditingGeneral] = useState(false);
  const [editingPayterms, setEditingPayterms] = useState(false);
  const [editingContainer, setEditingContainer] = useState(false);
  const [editingBulk, setEditingBulk] = useState(false);
  const [savedGeneral, setSavedGeneral] = useState(true);
  const [savedPayterms, setSavedPayterms] = useState(true);
  const [savedContainer, setSavedContainer] = useState(true);
  const [savedBulk, setSavedBulk] = useState(true);
  // const [editssaved, setEditssaved] = useState(true);

  // Deliver Options
  const [containeroptions, setContaineroptions] = useState(containerInit);
  const [containeroptionsData, setContaineroptionsData] = useState(containerDataInit);
  const [bulkoptions, setBulkoptions] = useState(bulkInit);
  const [bulkoptionsData, setBulkoptionsData] = useState(bulkDataInit);

  // Payment Terms
  const [paymentterm, setPaymentterm] = useState(paytermInit);
  const [paymenttermData, setPaymenttermData] = useState(paytermDataInit);

  // List Data
  const [listdata, setListdata] = useState([]);
  const [reloadlistdata, setReloadlistdata] = useState(false);
  const [clearSelectedRowID, setClearSelectedRowID] = useState(true);

  //SF Clear
  const [toggleClearSF, setToggleClearSF] = useState(false);
  const [showPSearch, setShowPSearch] = useState(false);

  // Clear Data
  const clearPosition = () => {
    setEditing(false);
    setPosition(positionInit);
    setPositionData(positionDataInit);
    setPaymentterm(paytermInit);
    setPaymenttermData(paytermDataInit);
    setContaineroptions(containerInit);
    setContaineroptionsData(containerDataInit);
    setBulkoptions(bulkInit);
    setBulkoptionsData(bulkDataInit);
    setPositiontoedit(null);
    setClearSelectedRowID(false);
    setToggleClearSF(!toggleClearSF);
    setEditingGeneral(false);
    setEditingPayterms(false);
    setEditingContainer(false);
    setEditingBulk(false);
  };

  // Show Saved Position Message
  const [SPM, setSPM] = useState();
  const [showSPM, setShowSPM] = useState(false);
  const onSPMComplete = () => {
    setSPM(null);
  };
  useEffect(() => {
    const elem = SPMRef.current;
    gsap.fromTo(
      elem,
      { opacity: 1 },
      {
        opacity: 0,
        duration: 2.5,
        ease: "power1.inOut",
        onComplete: onSPMComplete,
      }
    );
  }, [showSPM]);

  // Load List Data
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getPositions = async () => {
      try {
        const response = await axiosPrivate.get("/api/positions/getpositions");
        setListdata(response.data);
      } catch (err) {
        navigate("/login", { state: { from: location }, replace: true });
      }
    };
    getPositions();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [reloadlistdata]);

  // Save Position
  const saveNewPosition = async () => {
    try {
      const response = await axiosPrivate.post("/api/positions/addnewposition", {
        positionData,
      });
      if (response.data.message === "Saved") {
        const response1 = await axiosPrivate.post("/api/positions/addpospayterms", {
          paymenttermData,
          positionID: response.data.positionID,
        });
        if (response1.data.message === "Saved") {
          const response2 = await axiosPrivate.post("/api/positions/addposcontaineroptions", {
            containeroptionsData,
            positionID: response.data.positionID,
          });
          if (response2.data.message === "Saved") {
            const response3 = await axiosPrivate.post("/api/positions/addposbulkoptions", {
              bulkoptionsData,
              positionID: response.data.positionID,
            });
            if (response3.data.message === "Saved") {
              setSPM(response.data.message);
              setShowSPM(!showSPM);
              clearPosition();
              setReloadlistdata(!reloadlistdata);
            }
          }
        }
      }
    } catch (err) {
      navigate("/login", { state: { from: location }, replace: true });
    }
  };

  //Select and Load Position to Edit - Listwithfilter callback -
  const selectPositionToEdit = (item) => {
    clearPosition();
    setPositiontoedit(item.positionID);
  };

  // Load Position to Edit
  useLoadSupPositionToEdit(
    positiontoedit,
    setToggleClearSF,
    toggleClearSF,
    axiosPrivate,
    navigate,
    location,
    setPosition,
    setPositionData,
    setPaymentterm,
    setPaymenttermData,
    paytermInit,
    paytermDataInit,
    editing,
    setEditingGeneral,
    editingPayterms,
    editingContainer,
    editingBulk,
    setEditingPayterms,
    setEditingContainer,
    setEditingBulk,
    editingGeneral,
    setContaineroptions,
    setContaineroptionsData,
    setBulkoptions,
    setBulkoptionsData,
    setShowPSearch,
    reloadposition,
    setEditing
  );

  // Reload positions after receiving "Saved" msg from server for all sent updates
  useEffect(() => {
    if (editing && savedGeneral && savedPayterms && savedContainer && savedBulk) {
      setReloadposition(!reloadposition);
      setReloadlistdata(!reloadlistdata);
      setSPM("Succesfully Saved Edits");
      setShowSPM(!showSPM);
    }
  }, [savedGeneral, savedPayterms, savedContainer, savedBulk]);

  // Save Edits
  const saveGeneralEdits = async () => {
    try {
      const response = await axiosPrivate.post("/api/positions/updateposition", {
        positionData,
      });
      if (response.data.message === "Saved") {
        setSavedGeneral(true);
      }
    } catch (err) {
      navigate("/login", { state: { from: location }, replace: true });
    }
  };

  // Save Payterm Edits
  const savePaytermEdits = async () => {
    try {
      const response = await axiosPrivate.post("/api/positions/updatepospayterms", {
        positionID: positiontoedit,
        paymenttermData: paymenttermData,
      });
      if (response.data.message === "Saved") {
        setSavedPayterms(true);
      }
    } catch (err) {
      navigate("/login", { state: { from: location }, replace: true });
    }
  };

  // Save Container Option Edits
  const saveContainerEdits = async () => {
    try {
      const response = await axiosPrivate.post("/api/positions/updateposshipoptions", {
        positionID: positiontoedit,
        shipoptionsData: containeroptionsData,
        shipType: "container",
      });
      if (response.data.message === "Saved") {
        setSavedContainer(true);
      }
    } catch (err) {
      navigate("/login", { state: { from: location }, replace: true });
    }
  };
  // Save Bulk Option Edits
  const saveBulkEdits = async () => {
    try {
      const response = await axiosPrivate.post("/api/positions/updateposshipoptions", {
        positionID: positiontoedit,
        shipoptionsData: bulkoptionsData,
        shipType: "bulk",
      });
      if (response.data.message === "Saved") {
        setSavedBulk(true);
      }
    } catch (err) {
      navigate("/login", { state: { from: location }, replace: true });
    }
  };

  // SearchField OnSelect Functions
  // ProdSupplier
  const handleProductSelect = (item) => {
    if (editing && !editingGeneral) {
      setEditingGeneral(true);
      setSavedGeneral(false);
    }
    setPosition({
      ...position,
      ["product"]: item.product,
      ["supplier"]: item.supplier,
    });
    setPositionData({
      ...positionData,
      ["productID"]: item.productID,
      ["supplierID"]: item.supplierID,
    });
  };
  //Buyer
  const handleBuyerSelect = (item) => {
    if (editing && !editingGeneral) {
      setEditingGeneral(true);
      setSavedGeneral(false);
    }
    setPosition({
      ...position,
      ["buyer"]: item.buyer,
    });
    setPositionData({
      ...positionData,
      ["buyerID"]: item.buyerID,
    });
  };

  // Position Text Change
  const handlePosTextChange = (e) => {
    // const isASCIIText = RegExp("^[a-zA-Z0-9,.$]");
    const isASCIIText = RegExp("^[\x00-\x7F]+$");
    if (isASCIIText.test(e.target.value) || e.target.value === "") {
      if (editing && !editingGeneral) {
        setEditingGeneral(true);
        setSavedGeneral(false);
      }
      setNoteswarning("");
      setPosition({
        ...position,
        [e.target.name]: e.target.value,
      });
      setPositionData({
        ...positionData,
        [e.target.name]: e.target.value,
      });
    } else {
      setNoteswarning("Please type only ASCII characters.");
    }
  };

  // Text Integer Change
  const handleTextIntegerChange = (e) => {
    const isInteger = RegExp("^[0-9]+$");
    if (isInteger.test(e.target.value) || e.target.value === "") {
      if (editing && !editingGeneral) {
        setEditingGeneral(true);
        setSavedGeneral(false);
      }
      setPosition({
        ...position,
        [e.target.name]: e.target.value,
      });
      setPositionData({
        ...positionData,
        [e.target.name]: e.target.value,
      });
    }
  };

  // Decimal Change and Blur
  const handleDecimalChange = (e, decim = 2) => {
    // const isdecimalnumber = RegExp("^[0-9.]+$");
    const isdecimalnumber = RegExp("^[0-9]*[.]{0,1}[0-9]*$");
    if (isdecimalnumber.test(e.target.value) || e.target.value === "") {
      if (editing && !editingGeneral) {
        setEditingGeneral(true);
        setSavedGeneral(false);
      }
      setPosition({
        ...position,
        [e.target.name]: e.target.value,
      });
      setPositionData({
        ...positionData,
        [e.target.name]: Number(Number(e.target.value).toFixed(decim)),
      });
    }
  };
  const handleDecimalBlur = (e, dec = 2) => {
    setPosition({
      ...position,
      [e.target.name]: Number(e.target.value.replace(",", ""))
        .toFixed(dec)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
    });
    if (e.target.value === "") {
      setPositionData({ ...positionData, [e.target.name]: 0 });
    }
  };

  // Percentage Change and Blur
  const handlePercentageChange = (e, dec = 2) => {
    const isdecimalnumber = RegExp("^[0-9]*[.]{0,1}[0-9%]*$");
    if (isdecimalnumber.test(e.target.value) || e.target.value === "") {
      if (editing && !editingGeneral) {
        setEditingGeneral(true);
        setSavedGeneral(false);
      }
      if (e.target.value.toString().includes("%")) {
        setPositionData({
          ...positionData,
          [e.target.name]: Number(e.target.value.replace("%", "")).toFixed(dec) / 100,
        });
        setPosition({
          ...position,
          [e.target.name]: e.target.value.replace("%", ""),
        });
      } else {
        setPositionData({
          ...positionData,
          [e.target.name]: Number(e.target.value).toFixed(dec) / 100,
        });
        setPosition({
          ...position,
          [e.target.name]: e.target.value,
        });
      }
    }
  };
  const handlePercentageBlur = (e, dec = 2) => {
    setPosition({
      ...position,
      [e.target.name]: Number(e.target.value.replace("%", "")).toFixed(dec) + "%",
    });
  };

  // Position Search Component
  useEffect(() => {
    if (showPSearch) {
      const elem = psearchRef.current;
      gsap.to(elem, {
        bottom: "-1vh",
        duration: 0.1,
        ease: "power1.inOut",
      });
    }
    if (!showPSearch) {
      const elem = psearchRef.current;
      gsap.to(elem, {
        bottom: "-73vh",
        duration: 0.1,
        ease: "power1.inOut",
      });
    }
  }, [showPSearch]);

  // Handle paymentterm input changes
  const handlePaytermInputChange = (ind, el1, e) => {
    const temp = paymentterm[ind];
    const tempdata = paymenttermData[ind];
    if (el1 === "portion") {
      const isdecimalnumber = RegExp("^[0-9]*[.]{0,1}[0-9%]*$");
      if (isdecimalnumber.test(e.target.value) || e.target.value === "") {
        if (editing && !editingPayterms) {
          setEditingPayterms(true);
          setSavedPayterms(false);
        }
        if (e.target.value.toString().includes("%")) {
          tempdata[e.target.name] = Number(e.target.value.replace("%", "")).toFixed(2) / 100;
          temp[e.target.name] = e.target.value.replace("%", "");
        } else {
          tempdata[e.target.name] = Number(e.target.value).toFixed(2) / 100;
          temp[e.target.name] = e.target.value;
        }
      }
    } else if (el1 === "termdays") {
      const isInteger = RegExp("^[0-9]+$");
      if (isInteger.test(e.target.value) || e.target.value === "") {
        if (editing && !editingPayterms) {
          setEditingPayterms(true);
          setSavedPayterms(false);
        }
        temp[e.target.name] = e.target.value;
        tempdata[e.target.name] = Number(e.target.value);
      }
    }
    setPaymentterm([...paymentterm.slice(0, ind), temp, ...paymentterm.slice(ind + 1, paymentterm.length)]);
    setPaymenttermData([
      ...paymenttermData.slice(0, ind),
      tempdata,
      ...paymenttermData.slice(ind + 1, paymenttermData.length),
    ]);
  };
  // Handle Payment Term Input Blur
  const handlePaytermInputBlur = (ind, el1, e) => {
    const temp = paymentterm[ind];
    if (el1 === "portion") {
      temp[e.target.name] = Number(e.target.value.replace("%", "")).toFixed(2) + "%";
    }
    setPaymentterm([...paymentterm.slice(0, ind), temp, ...paymentterm.slice(ind + 1, paymentterm.length)]);
  };

  // Handle PayType Selection
  const SelectPayType = (item, ind) => {
    const temp = paymentterm[ind];
    const tempdata = paymenttermData[ind];
    temp["payType"] = item.payType;
    tempdata["payTypeID"] = item.payTypeID;
    setPaymentterm([...paymentterm.slice(0, ind), temp, ...paymentterm.slice(ind + 1, paymentterm.length)]);
    setPaymenttermData([
      ...paymenttermData.slice(0, ind),
      tempdata,
      ...paymenttermData.slice(ind + 1, paymenttermData.length),
    ]);
    if (editing && !editingPayterms) {
      setEditingPayterms(true);
      setSavedPayterms(false);
    }
  };

  // Handle Select Container Option Input Field
  const SelectContainerOption = (item, el1, ind) => {
    const temp = containeroptions[ind];
    const tempdata = containeroptionsData[ind];
    temp[el1] = item[el1];
    tempdata[el1 + "ID"] = item[el1 + "ID"];
    setContaineroptions([
      ...containeroptions.slice(0, ind),
      temp,
      ...containeroptions.slice(ind + 1, containeroptions.length),
    ]);
    setContaineroptionsData([
      ...containeroptionsData.slice(0, ind),
      tempdata,
      ...containeroptionsData.slice(ind + 1, containeroptionsData.length),
    ]);
    if (editing && !editingContainer) {
      setEditingContainer(true);
      setSavedContainer(false);
    }
  };

  // handle Container Input Change
  const handleContainerInputChange = (ind, el1, e) => {
    const temp = containeroptions[ind];
    const tempdata = containeroptionsData[ind];
    if (el1 === "price") {
      const isUScurrency = RegExp("^[$]{0,1}[0-9]*[.]{0,1}[0-9%]*$");
      if (isUScurrency.test(e.target.value) || e.target.value === "") {
        if (editing && !editingContainer) {
          setEditingContainer(true);
          setSavedContainer(false);
        }
        tempdata[el1] = Number(Number(e.target.value.replace("$", "")).toFixed(2));
        temp[el1] = e.target.value;
      }
    } else if (el1 === "marks") {
      const isASCIIText = RegExp("^[\x00-\x7F]+$");
      if (isASCIIText.test(e.target.value) || e.target.value === "") {
        if (editing && !editingContainer) {
          setEditingContainer(true);
          setSavedContainer(false);
        }
        tempdata[el1] = e.target.value;
        temp[el1] = e.target.value;
      }
    } else {
      if (editing && !editingContainer) {
        setEditingContainer(true);
        setSavedContainer(false);
      }
      tempdata[el1] = e.target.value;
      temp[el1] = e.target.value;
    }
    setContaineroptions([
      ...containeroptions.slice(0, ind),
      temp,
      ...containeroptions.slice(ind + 1, containeroptions.length),
    ]);
    setContaineroptionsData([
      ...containeroptionsData.slice(0, ind),
      tempdata,
      ...containeroptionsData.slice(ind + 1, containeroptionsData.length),
    ]);
  };
  // Handle Container Input Blur
  const handleContainerInputBlur = (ind, el1, e) => {
    const temp = containeroptions[ind];
    if (el1 === "price") {
      temp[el1] = "$" + Number(e.target.value.replace("$", "")).toFixed(2);
    }
    setContaineroptions([
      ...containeroptions.slice(0, ind),
      temp,
      ...containeroptions.slice(ind + 1, containeroptions.length),
    ]);
  };

  // Handle Select Bulk Option Input Field
  const SelectBulkOption = (item, el1, ind) => {
    const temp = bulkoptions[ind];
    const tempdata = bulkoptionsData[ind];
    temp[el1] = item[el1];
    tempdata[el1 + "ID"] = item[el1 + "ID"];
    setBulkoptions([...bulkoptions.slice(0, ind), temp, ...bulkoptions.slice(ind + 1, bulkoptions.length)]);
    setBulkoptionsData([
      ...bulkoptionsData.slice(0, ind),
      tempdata,
      ...bulkoptionsData.slice(ind + 1, bulkoptionsData.length),
    ]);
    if (editing && !editingBulk) {
      setEditingBulk(true);
      setSavedBulk(false);
    }
  };

  // handle Bulk Input Change
  const handleBulkInputChange = (ind, el1, e) => {
    const temp = bulkoptions[ind];
    const tempdata = bulkoptionsData[ind];
    if (el1 === "price") {
      const isUScurrency = RegExp("^[$]{0,1}[0-9]*[.]{0,1}[0-9%]*$");
      if (isUScurrency.test(e.target.value) || e.target.value === "") {
        if (editing && !editingBulk) {
          setEditingBulk(true);
          setSavedBulk(false);
        }
        tempdata[el1] = Number(Number(e.target.value.replace("$", "")).toFixed(2));
        temp[el1] = e.target.value;
      }
    } else if (el1 === "marks") {
      const isASCIIText = RegExp("^[\x00-\x7F]+$");
      if (isASCIIText.test(e.target.value) || e.target.value === "") {
        if (editing && !editingBulk) {
          setEditingBulk(true);
          setSavedBulk(false);
        }
        tempdata[el1] = e.target.value;
        temp[el1] = e.target.value;
      }
    } else {
      if (editing && !editingBulk) {
        setEditingBulk(true);
        setSavedBulk(false);
      }
      tempdata[el1] = e.target.value;
      temp[el1] = e.target.value;
    }
    setBulkoptions([...bulkoptions.slice(0, ind), temp, ...bulkoptions.slice(ind + 1, bulkoptions.length)]);
    setBulkoptionsData([
      ...bulkoptionsData.slice(0, ind),
      tempdata,
      ...bulkoptionsData.slice(ind + 1, bulkoptionsData.length),
    ]);
  };

  // Handle Bulk Input Blur
  const handleBulkInputBlur = (ind, el1, e) => {
    const temp = bulkoptions[ind];
    if (el1 === "price") {
      temp[el1] = "$" + Number(e.target.value.replace("$", "")).toFixed(2);
    }
    setBulkoptions([...bulkoptions.slice(0, ind), temp, ...bulkoptions.slice(ind + 1, bulkoptions.length)]);
  };

  return (
    <div className='addpos-container'>
      <form
        className='addposition'
        onSubmit={(e) => {
          e.preventDefault();
          if (editing === false) {
            saveNewPosition();
            // setReloadlistdata(!reloadlistdata);
          }
          if (editing === true) {
            if (editingGeneral) {
              saveGeneralEdits();
            }
            if (editingPayterms) {
              savePaytermEdits();
            }
            if (editingContainer) {
              saveContainerEdits();
            }
            if (editingBulk) {
              saveBulkEdits();
            }
          }
        }}
        onClick={(e) => {
          setShowPSearch(false);
        }}
      >
        <div className='addpos-header'>
          <h1>{editing ? "Edit Supplier Position:" : "Add New Supplier Position:"}</h1>
          <div className='form-buttons'>
            <span style={{ color: "var(--green)", marginTop: "1rem" }} ref={SPMRef}>
              {SPM}
            </span>
            <button
              type='button'
              tabIndex={201}
              onClick={(e) => {
                clearPosition();
              }}
            >
              Clear
            </button>
            {editing === false && (
              <button className='mainbutton' type='submit' tabIndex={201}>
                Save New
              </button>
            )}
            {editing === true && (
              <button
                disabled={!editingGeneral && !editingPayterms && !editingContainer && !editingBulk}
                className={
                  !editingGeneral && !editingPayterms && !editingContainer && !editingBulk
                    ? "mainbutton btndisabled"
                    : "mainbutton"
                }
                type='submit'
                tabIndex={201}
              >
                Save Edits
              </button>
            )}
          </div>
        </div>
        <section className='addpos-top'>
          <section className='addpos-1'>
            <div className='form-group'>
              <label>PosID:</label>
              <input
                readOnly
                disabled
                style={{ border: "none", background: "white" }}
                onKeyDown={ignoreEnter}
                value={position?.positionID || ""}
              ></input>
            </div>
            <div className='form-group'>
              <label>Pos Date:</label>
              <input
                disabled
                style={{ border: "none", background: "white" }}
                type='date'
                readOnly
                value={position?.posDate}
              />
            </div>
            <div className='form-group'>
              <label>WGP:</label>
              <input
                placeholder='5000...'
                onFocus={(e) => e.target.select()}
                onKeyDown={ignoreEnter}
                onChange={(e) => handleTextIntegerChange(e)}
                value={position?.WGP || ""}
                name='WGP'
              ></input>
            </div>
            <fieldset>
              <legend>General:</legend>
              <div className='form-group'>
                <label>Product:</label>
                <SearchField
                  required={true}
                  searchURL='/api/positions/getprodsupplier'
                  value={position?.product || ""}
                  valueName='product'
                  secondaryValueName='supplier'
                  valueID='productID'
                  style={{ width: "93%" }}
                  customplaceholder='Select Product'
                  onItemSelect={handleProductSelect}
                  clearfield={toggleClearSF}
                />
              </div>
              <div className='form-group'>
                <label>Supplier:</label>
                <input readOnly placeholder='Supplier...' onKeyDown={ignoreEnter} value={position?.supplier || ""} />
              </div>
              <div className='form-group'>
                <label>Buyer:</label>
                <SearchField
                  required={true}
                  searchURL='/api/positions/getbuyers'
                  value={position?.buyer || ""}
                  valueName='buyer'
                  valueID='productID'
                  style={{ width: "93%" }}
                  customplaceholder='Select Buyer'
                  onItemSelect={handleBuyerSelect}
                  clearfield={toggleClearSF}
                />
              </div>
            </fieldset>
            <fieldset>
              <legend>Quantity:</legend>
              <div className='form-group'>
                <label>Quantity (mt):</label>
                <input
                  required
                  autoComplete='off'
                  name='quantity'
                  placeholder='Quantity...'
                  onKeyDown={ignoreEnter}
                  onFocus={(e) => e.target.select()}
                  onChange={(e) => handleDecimalChange(e, 3)}
                  onBlur={(e) => handleDecimalBlur(e, 3)}
                  value={position?.quantity}
                ></input>
              </div>
              <div className='form-group'>
                <label>Tolerance:</label>
                <div
                  style={{ display: "flex", flexDirection: "row", alignItems: "baseline", justifyContent: "flex-end" }}
                >
                  <p>+/-</p>
                  <input
                    required
                    autoComplete='off'
                    style={{ minWidth: "25%", width: "20%", marginLeft: "1rem" }}
                    placeholder='% ...'
                    name='tolerance'
                    onKeyDown={ignoreEnter}
                    onFocus={(e) => e.target.select()}
                    onChange={(e) => handlePercentageChange(e, 2)}
                    onBlur={(e) => handlePercentageBlur(e, 2)}
                    value={position?.tolerance}
                  ></input>
                  {/* <p style={{ marginLeft: "1rem" }}>%</p> */}
                </div>
              </div>
            </fieldset>
            <fieldset>
              <legend>
                Payment Terms:{" "}
                <FontAwesomeIcon
                  icon={faPlusSquare}
                  onClick={(e) => {
                    if (editing && !editingPayterms) {
                      setEditingPayterms(true);
                      setSavedPayterms(false);
                    }
                    setPaymentterm([...paymentterm, { portion: "0.00%", payType: "CAD", termdays: "10" }]);
                    setPaymenttermData([...paymenttermData, { portion: 0, payTypeID: 1, termdays: 10 }]);
                  }}
                />
              </legend>
              <div className='paytermheader'>
                <p></p>
                <p>%</p>
                <p>Type</p>
                <p>Days</p>
                <p></p>
              </div>
              {paymentterm &&
                paymentterm.map((el, ind) => {
                  let paykeys = Object.keys(el);
                  return (
                    <div key={"posrow-" + ind} className='paytermrow'>
                      <p>{ind + 1 + ":"}</p>
                      {paykeys &&
                        paykeys.map((el1) => {
                          if (el1 !== "positionID" && el1 !== "posPaytermID") {
                            if (el1 !== "payType") {
                              return (
                                <input
                                  required
                                  autoComplete='off'
                                  key={ind + "-" + el1}
                                  name={el1}
                                  value={el[el1]}
                                  onFocus={(e) => e.target.select()}
                                  onChange={(e) => {
                                    handlePaytermInputChange(ind, el1, e);
                                  }}
                                  onBlur={(e) => {
                                    handlePaytermInputBlur(ind, el1, e);
                                  }}
                                />
                              );
                            } else {
                              return (
                                <SearchField
                                  key={ind + "-" + el1}
                                  required={true}
                                  searchURL='/api/positions/getpaytypes'
                                  value={el[el1] || ""}
                                  valueName='payType'
                                  valueID='payTypeID'
                                  style={{ width: "40%" }}
                                  customplaceholder='payType'
                                  onItemSelect={(item) => {
                                    SelectPayType(item, ind);
                                  }}
                                  clearfield={toggleClearSF}
                                />
                              );
                            }
                          }
                        })}
                      <p>
                        <FontAwesomeIcon
                          icon={faMinusSquare}
                          onClick={(e) => {
                            if (paymentterm.length > 1) {
                              if (editing && !editingPayterms) {
                                setEditingPayterms(true);
                                setSavedPayterms(false);
                              }
                              setPaymentterm((prev) => [...prev.slice(0, ind), ...prev.slice(ind + 1, prev.length)]);
                              setPaymenttermData((prev) => [
                                ...prev.slice(0, ind),
                                ...prev.slice(ind + 1, prev.length),
                              ]);
                            }
                          }}
                        />
                      </p>
                    </div>
                  );
                })}
            </fieldset>
            <fieldset>
              <legend>Notes:</legend>
              <textarea
                onFocus={(e) => e.target.select()}
                name='notes'
                onChange={(e) => handlePosTextChange(e)}
                value={position?.notes || ""}
              />
              <span style={{ color: "red" }}>{noteswarning}</span>
            </fieldset>
          </section>

          {/* CONTAINER DELIVERY */}
          <section className='addpos-4'>
            <fieldset>
              <legend>
                Container Delivery
                <FontAwesomeIcon
                  icon={faPlusSquare}
                  onClick={(e) => {
                    if (editing && !editingContainer) {
                      setEditingContainer(true);
                      setSavedContainer(false);
                    }
                    setContaineroptions([
                      ...containeroptions,
                      { incoterm: "FOB", port: "", bagSize: "", marks: "", price: "", shipFrom: "", shipTo: "" },
                    ]);
                    setContaineroptionsData([
                      ...containeroptionsData,
                      { incotermID: 4, portID: "", bagSizeID: "", marks: "", price: "", shipFrom: "", shipTo: "" },
                    ]);
                  }}
                />
              </legend>
              {containeroptions &&
                containeroptions.map((el, ind) => {
                  let keys = Object.keys(el);
                  return (
                    <div key={"coption-" + ind} className='container-option'>
                      <h3>
                        {"Option " + (ind + 1)}
                        <FontAwesomeIcon
                          icon={faMinusSquare}
                          style={{ marginLeft: "1rem", color: "var(--purple)" }}
                          onClick={(e) => {
                            if (editing && !editingContainer) {
                              setEditingContainer(true);
                              setSavedContainer(false);
                            }
                            setContaineroptions((prev) => [...prev.slice(0, ind), ...prev.slice(ind + 1, prev.length)]);
                            setContaineroptionsData((prev) => [
                              ...prev.slice(0, ind),
                              ...prev.slice(ind + 1, prev.length),
                            ]);
                          }}
                        />
                      </h3>
                      {keys &&
                        keys.map((el1) => {
                          if (el1 !== "posShipOptionID") {
                            if (el1 === "incoterm" || el1 === "port" || el1 === "bagSize") {
                              return (
                                <div key={ind + el1} className='form-group'>
                                  <label>
                                    {el["incoterm"] === "FOB" && el1 === "port"
                                      ? "POL:"
                                      : el["incoterm"] !== "FOB" && el1 === "port"
                                      ? "POD:"
                                      : el1 + ":"}
                                  </label>
                                  <SearchField
                                    required={true}
                                    searchURL={"/api/positions/get" + el1 + "s"}
                                    value={el[el1] || ""}
                                    valueName={el1}
                                    valueID={el1 + "ID"}
                                    customplaceholder={el1}
                                    onItemSelect={(item) => SelectContainerOption(item, el1, ind)}
                                    clearfield={toggleClearSF}
                                    secondaryValueName={el1 === "port" ? "country" : ""}
                                  />
                                </div>
                              );
                            }
                            if (el1 === "shipFrom" || el1 === "shipTo") {
                              return (
                                <div key={ind + el1} className='form-group'>
                                  <label>{el1}</label>
                                  <input
                                    type='date'
                                    required
                                    name={el1}
                                    value={el[el1]}
                                    onFocus={(e) => e.target.select()}
                                    onChange={(e) => handleContainerInputChange(ind, el1, e)}
                                  />
                                </div>
                              );
                            }
                            return (
                              <div key={ind + el1} className='form-group'>
                                <label>{el1}</label>
                                <input
                                  required
                                  autoComplete='off'
                                  name={el1}
                                  value={el[el1]}
                                  placeholder={el1}
                                  onFocus={(e) => e.target.select()}
                                  onChange={(e) => handleContainerInputChange(ind, el1, e)}
                                  onBlur={(e) => handleContainerInputBlur(ind, el1, e)}
                                  clearfield={toggleClearSF}
                                />
                              </div>
                            );
                          }
                        })}
                    </div>
                  );
                })}
            </fieldset>
          </section>

          {/* BULK DELIVERY */}
          <section className='addpos-5'>
            <fieldset>
              <legend>
                Break Bulk Delivery
                <FontAwesomeIcon
                  icon={faPlusSquare}
                  onClick={(e) => {
                    if (editing && !editingBulk) {
                      setEditingBulk(true);
                      setSavedBulk(false);
                    }
                    setBulkoptions([
                      ...bulkoptions,
                      { incoterm: "FOB", port: "", bagSize: "", marks: "", price: "", shipFrom: "", shipTo: "" },
                    ]);
                    setBulkoptionsData([
                      ...bulkoptionsData,
                      { incotermID: 4, portID: "", bagSizeID: "", marks: "", price: "", shipFrom: "", shipTo: "" },
                    ]);
                  }}
                />
              </legend>
              {bulkoptions &&
                bulkoptions.map((el, ind) => {
                  let keys = Object.keys(el);
                  return (
                    <div key={"boption-" + ind} className='container-option'>
                      <h3>
                        {"Option " + (ind + 1)}
                        <FontAwesomeIcon
                          icon={faMinusSquare}
                          style={{ marginLeft: "1rem", color: "var(--purple)" }}
                          onClick={(e) => {
                            if (editing && !editingBulk) {
                              setEditingBulk(true);
                              setSavedBulk(false);
                            }
                            setBulkoptions((prev) => [...prev.slice(0, ind), ...prev.slice(ind + 1, prev.length)]);
                            setBulkoptionsData((prev) => [...prev.slice(0, ind), ...prev.slice(ind + 1, prev.length)]);
                          }}
                        />
                      </h3>
                      {keys &&
                        keys.map((el1) => {
                          if (el1 !== "posShipOptionID") {
                            if (el1 === "incoterm" || el1 === "port" || el1 === "bagSize") {
                              return (
                                <div key={ind + el1} className='form-group'>
                                  <label>
                                    {el["incoterm"] === "FOB" && el1 === "port"
                                      ? "POL:"
                                      : el["incoterm"] !== "FOB" && el1 === "port"
                                      ? "POD:"
                                      : el1 + ":"}
                                  </label>
                                  <SearchField
                                    required={true}
                                    searchURL={"/api/positions/get" + el1 + "s"}
                                    value={el[el1] || ""}
                                    valueName={el1}
                                    valueID={el1 + "ID"}
                                    customplaceholder={el1}
                                    onItemSelect={(item) => SelectBulkOption(item, el1, ind)}
                                    clearfield={toggleClearSF}
                                    secondaryValueName={el1 === "port" ? "country" : ""}
                                  />
                                </div>
                              );
                            }
                            if (el1 === "shipFrom" || el1 === "shipTo") {
                              return (
                                <div key={ind + el1} className='form-group'>
                                  <label>{el1}</label>
                                  <input
                                    type='date'
                                    required
                                    name={el1}
                                    value={el[el1]}
                                    onFocus={(e) => e.target.select()}
                                    onChange={(e) => handleBulkInputChange(ind, el1, e)}
                                  />
                                </div>
                              );
                            }
                            return (
                              <div key={ind + el1} className='form-group'>
                                <label>{el1}</label>
                                <input
                                  required
                                  name={el1}
                                  autoComplete='off'
                                  value={el[el1]}
                                  placeholder={el1}
                                  onFocus={(e) => e.target.select()}
                                  onChange={(e) => handleBulkInputChange(ind, el1, e)}
                                  onBlur={(e) => handleBulkInputBlur(ind, el1, e)}
                                />
                              </div>
                            );
                          }
                        })}
                    </div>
                  );
                })}
            </fieldset>
          </section>
        </section>
      </form>
      <div ref={psearchRef} className='possearch' tabIndex={-1}>
        <div className='possearch-header' onClick={(e) => setShowPSearch(!showPSearch)}>
          {!showPSearch ? <FontAwesomeIcon icon={faAnglesUp} /> : <FontAwesomeIcon icon={faAnglesDown} />}
        </div>
        <div style={{ marginTop: "1rem" }}>
          <ListWithFilters
            data={listdata}
            columns={[
              // "positionID",
              "WGP",
              "abbreviation",
              "supplier",
              "buyer",
              "quantity",
              "incoterm",
              "port",
              "bagSize",
              "price",
              "shipType",
              "shipFrom",
              "shipTo",
            ]}
            rowID={"positionID"}
            // sortable={true}
            // sortDirections={["ASC", "NON", "NON", "NON", "NON"]}
            size={[/*"S"*/ "S", "M", "M", "M", "S", "S", "M", "M", "S", "S", "S", "S"]}
            onRowClick={selectPositionToEdit}
            placeHolders={true}
            clearSelectedRowID={clearSelectedRowID}
            setClearSelectedRowID={setClearSelectedRowID}
            tabIndex={-1}
            // editableRows={true}
            // rowIndex={true}
          />
        </div>
      </div>
    </div>
  );
};

export default PositionsSupplier;
